export class SnsInfo{
    // 1: twitter
    // 2: facebook
    // public selectSnsType = 2;
    // 選択した投稿の数
    public snsContentsLength = 0;
}
